import { For, Match, Show, Switch, createEffect, createMemo } from "solid-js";
import { WorkshopCard } from "./components/workshop-card";
import { solidstate } from ":setup/qstate";
import { workshops } from "./apis";
import { Loader2 } from ":src/components/loaders";
import { createInput, createSelect } from ":ui/form";

export default function Workshops() {
  const $list = solidstate.createAsync(workshops.get);
  const $applied_filter = solidstate.create({} as { search?: string; category?: string });
  const $filters = createMemo(() => {
    const result = {
      search: ["title", "category"],
      categories: [],
    };
    const list = $list.value;
    if (list == undefined) {
      return result;
    }
    for (const item of list) {
      if (item == undefined) {
        continue;
      }
      const category = item.category;
      if (!result.categories.includes(category)) {
        result.categories.push(category);
      }
    }

    return result;
  });
  const Search = createInput(null);
  const FilterCategory = createSelect(null);

  createEffect(() => {
    const search = Search.control.value;
    $applied_filter.set((s) => ({ ...s, search: search }));
  });
  createEffect(() => {
    const category = FilterCategory.control.value;
    $applied_filter.set((s) => ({ ...s, category: category }));
  });

  return (
    <section class="flex flex-col w-full min-h-full h-full px-5 py-3  <md:(px-2 py-1) ">
      <h1 class="text-xl  font-[600] text-black z-1 <md:(text-22px )">Workshops</h1>
      <div class="flex flex-row w-full justify-between items-center gap-2 py-2 <sm:(!flex-col !gap-x-0)">
        <Search.Input autocomplete="search" class="form-input" placeholder="Search by name..." />
        <FilterCategory.Select
          class="form-select !w-30% <sm:(!w-full)"
          placeholder="Filter By Category..."
          options={$filters().categories}
          allowClearSelected
        />
      </div>
      <Switch>
        <Match when={$list.state.loading}>
          <Loader2 msg="Loading Resources..." />
        </Match>
        <Match when={$list.state.failed}>an error occurred while fetching {$list.error}</Match>
        <Match when={$list.state.success}>
          <div class="grid grid-cols-4 w-full  gap-x-1rem gap-4 h-fit  overflow-x-hidden !overflow-y-auto py-6 scrollbar <md:(!grid-cols-1 py-2) ">
            <For each={$list.value}>
              {(item) => {
                const show = createMemo(() => {
                  const search_keywords = $filters().search;
                  const search = $applied_filter?.value?.search?.toLowerCase?.();
                  const category = $applied_filter?.value?.category;
                  if (
                    search != undefined &&
                    !search_keywords.some((prop) => item[prop]?.toLowerCase().includes(search))
                  ) {
                    return false;
                  }
                  if (category != undefined && item?.category !== category) {
                    if (category === "undefined" && item.category == undefined) {
                      return true;
                    }
                    return false;
                  }

                  return true;
                });

                return (
                  <Show when={show()}>
                    <WorkshopCard {...item} />
                  </Show>
                );
              }}
            </For>
          </div>
        </Match>
      </Switch>
    </section>
  );
}
